<template>
  <div class="scroll-tabs">
    <div class="left-arrow">
      <i class="fa-solid fa-angle-left arrow" v-if="isScroll" :class="{disabled:!isLeft}" @mousedown="moveLeft" @mouseup="moveClear"></i>
    </div>
    <div class="tabs-list" ref="scrollList">
      <slot></slot>
    </div>
    <div class="right-arrow" v-if="isScroll">
      <i class="fa-solid fa-angle-right arrow" :class="{disabled:!isRigth}" @mousedown="moveRight" @mouseup="moveClear"></i>
    </div>
  </div>
  
</template>

<script lang="ts">
import { defineComponent, ref, computed, onMounted, onBeforeUnmount, nextTick, Ref } from 'vue'

export default defineComponent({
  setup() {
    const scrollList = ref<HTMLElement>()
    const isScroll = ref(false)
    const position = ref(0)
    let intervalId: number | undefined = undefined
    const isLeft = computed(() => {
      return position.value > 0
    })
    const isRigth = computed(() => {
      if(!scrollList.value){
        return
      }
      return position.value !== (scrollList.value.scrollWidth - scrollList.value.offsetWidth)
    })
    const moveLeft = () => {
      // MEDICA_AS-1143 対応 setIntervalを中止
      if(!scrollList.value){
        return
      }
      let movedPosition = scrollList.value.scrollLeft - 50
      if (movedPosition < 0) {
        movedPosition = 0
        moveClear()
      }
      scrollList.value.scrollLeft = movedPosition
      position.value = movedPosition

      // intervalId = setInterval(() => {
      // if(!scrollList.value){
      //   return
      // }
      //   let movedPosition = scrollList.value.scrollLeft - 10
      //   if (movedPosition < 0) {
      //     movedPosition = 0
      //     moveClear()
      //   }
      //   scrollList.value.scrollLeft = movedPosition
      //   position.value = movedPosition
      // }, 20)
    }
    const moveRight = () => {
      // MEDICA_AS-1143 対応 setIntervalを中止
      if(!scrollList.value){
          return
      }

      let movedPosition = scrollList.value.scrollLeft + 50
      const maxWidth = scrollList.value.scrollWidth - scrollList.value.offsetWidth

      if (movedPosition > maxWidth) {
          movedPosition = maxWidth
          moveClear()
      }
      scrollList.value.scrollLeft = movedPosition
      position.value = movedPosition

      // intervalId = setInterval(() => {
      // if(!scrollList.value){
      //   return
      // }

      // let movedPosition = scrollList.value.scrollLeft + 10
      // const maxWidth = scrollList.value.scrollWidth - scrollList.value.offsetWidth

      //  if (movedPosition > maxWidth) {
      //    movedPosition = maxWidth
      //    moveClear()
      //  }
      //  scrollList.value.scrollLeft = movedPosition
      //  position.value = movedPosition
      //  }, 20)
    }
    const moveClear = () => {
      if (intervalId) {
        clearInterval(intervalId)
        intervalId = undefined
      }
    }
    const checkScroll = () => {
      if(!scrollList.value){
        return
      }
      scrollList.value.scrollLeft = position.value
      isScroll.value = scrollList.value.offsetWidth !== scrollList.value.scrollWidth
    }

    onMounted(() => {
      window.addEventListener('resize', checkScroll, true)
      nextTick(() => {
        checkScroll()
      })
    })

    onBeforeUnmount(() => {
      window.removeEventListener('resize', checkScroll, true)
    })
    
    return {
      scrollList,
      isScroll,
      position,
      isLeft,
      isRigth,
      moveLeft,
      moveRight,
      moveClear
    }
  }
})
</script>

<style scoped>
.scroll-tabs {
  width: calc(100% - 150px);
  display: flex;
  align-items: center;
}
.tabs-list {
  white-space: nowrap;
  overflow: hidden;
}
.left-arrow,
.right-arrow {
  width: 3.0em;
  min-width: 3.0em;
  text-align: center;
}
.arrow {
  cursor: pointer;
}
.arrow.disabled {
  pointer-events: none;
}
</style>
